export interface NestedObject {
  [key: string]: any
}

export interface FlattenedObject {
  [key: string]: any
}

export function flattenObject(
  obj: NestedObject,
  parentKey = '',
  result: FlattenedObject = {}
): FlattenedObject {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      const nestedKey = parentKey ? `${parentKey}.${key}` : key

      if (typeof value === 'object' && !Array.isArray(value)) {
        flattenObject(value, nestedKey, result)
      } else {
        result[nestedKey] = value
      }
    }
  }

  return result
}

export function unflattenObject(obj: FlattenedObject): NestedObject {
  const result: NestedObject = {}

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      const keys = key.split('.')

      let currentObj = result
      for (let i = 0; i < keys.length - 1; i++) {
        const currentKey = keys[i]

        if (!currentObj[currentKey]) {
          currentObj[currentKey] = {}
        }

        currentObj = currentObj[currentKey]
      }

      currentObj[keys[keys.length - 1]] = value
    }
  }

  return result
}

export const parseResourceLanguageKey = (key: string) => {
  return key?.replace('-', '_')
}

export const isEmptyValue = value => {
  if (value === null || value === undefined) {
    return true
  }
  if (typeof value === 'string') {
    return value.trim() === ''
  }
  return false
}
